import { Grid } from '@mui/material';
import { ComponentProps } from 'react';

export const getDashboardLayout = (hasAqi: boolean, hasWx: boolean, hasWorkRestProfile: boolean) => {
  let currentConditions: ComponentProps<typeof Grid> = {};
  let lightningStatus: ComponentProps<typeof Grid> = {};
  let workRest: ComponentProps<typeof Grid> = {};
  let aqi: ComponentProps<typeof Grid> = {};
  let conditionsTimeline: ComponentProps<typeof Grid> = {};

  // Lightning and current conditions are always cards. The rest is chaos based on what's available.
  // This is a mess. Let this die when we support customizable layouts.
  if (hasAqi && hasWx && hasWorkRestProfile) {
    currentConditions = {
      xs: 12,
      md: 6,
    };
    lightningStatus = {
      xs: 12,
      md: 6,
    };
    workRest = {
      xs: 12,
      md: 6,
      lg: 6,
      xl: 4,
    };
    aqi = {
      xs: 12,
      md: 6,
      lg: 6,
      xl: 3,
    };
    conditionsTimeline = {
      xs: 12,
      md: 6,
      lg: 12,
      xl: 5,
    };
  } else if (hasAqi && hasWx) {
    currentConditions = {
      xs: 12,
      md: 12,
      lg: 6,
    };
    lightningStatus = {
      xs: 12,
      md: 6,
    };
    aqi = {
      xs: 12,
      md: 6,
      lg: 4,
    };
    conditionsTimeline = {
      xs: 12,
      lg: 8,
    };
  } else if (hasWorkRestProfile && hasWx) {
    currentConditions = {
      xs: 12,
      md: 12,
      lg: 6,
    };
    lightningStatus = {
      xs: 12,
      md: 6,
    };
    workRest = {
      xs: 12,
      md: 6,
      lg: 4,
    };
    conditionsTimeline = {
      xs: 12,
      lg: 8,
    };
  } else if (hasWx) {
    currentConditions = {
      xs: 12,
      md: 12,
      lg: 6,
    };
    lightningStatus = {
      xs: 12,
      md: 6,
    };
    conditionsTimeline = {
      xs: 12,
    };
  } else if (hasAqi) {
    currentConditions = {
      xs: 12,
    };
    lightningStatus = {
      xs: 12,
      md: 6,
      lg: 8,
    };
    aqi = {
      xs: 12,
      md: 6,
      lg: 4,
    };
  } else if (hasWorkRestProfile) {
    currentConditions = {
      xs: 12,
    };
    lightningStatus = {
      xs: 12,
      md: 6,
      lg: 8,
    };
    workRest = {
      xs: 12,
      md: 6,
      lg: 4,
    };
  } else {
    currentConditions = {
      xs: 6,
    };
    lightningStatus = {
      xs: 6,
    };
  }

  return { currentConditions, lightningStatus, workRest, aqi, conditionsTimeline };
};
